export default `
mutation moveInQuote($quoteId: String!, $cartId: String!) {
    moveInQuote(quoteId: $quoteId, cartId: $cartId) {
        result
        warnings
    }
}
`;
